import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { store } from './store';
import { initializeAuth } from './store/authSlice';
import GrammarChecker from './components/GrammarChecker';
import './App.css';

function App() {
  useEffect(() => {
    // 在应用启动时初始化认证状态
    store.dispatch(initializeAuth());
  }, []);

  return (
    <HelmetProvider>
      <Provider store={store}>
        <div className="App">
          <GrammarChecker />
        </div>
      </Provider>
    </HelmetProvider>
  );
}

export default App;